module.exports = {
  'name': 'false',
  'category': 'Constants',
  'syntax': [
    'false'
  ],
  'description': 'Boolean value false',
  'examples': [
    'false'
  ],
  'seealso': ['true']
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/docs/constants/false.js
// module id = 927
// module chunks = 0